import * as React from 'react';
import IconBase, { IconBaseProps } from '../components/Icons/IconBase';
const props = {};

const SvgLollipop = (allProps: IconBaseProps) => {
  return (
    <IconBase {...allProps}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M13.1908 17.5337C17.504 17.5337 21.0005 14.0372 21.0005 9.72407C21.0005 5.41094 17.504 1.91446 13.1908 1.91446C8.87771 1.91446 5.38123 5.41094 5.38123 9.72407C5.38123 14.0372 8.87771 17.5337 13.1908 17.5337Z"
          stroke="currentColor"
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.12378 15.9922L2.36907 21.0497"
          stroke="currentColor"
          strokeWidth={2}
          strokeLinecap="round"
        />
        <path
          d="M7.3512 4.86468C9.61143 2.70221 13.6506 3.24283 15.5364 5.60843C17.3445 7.33833 17.3445 10.2776 15.5364 12.0079C14.0898 13.3919 11.7446 13.3919 10.298 12.0079C9.14083 10.9008 9.14083 9.10562 10.298 7.9985C11.2237 7.11281 12.7248 7.11281 13.6506 7.9985"
          stroke="currentColor"
          strokeWidth={2}
          strokeMiterlimit={10}
          strokeLinecap="round"
        />
      </svg>
    </IconBase>
  );
};

SvgLollipop.displayName = 'SvgLollipop';
export default SvgLollipop;
